import React from "react";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import { Sidebar } from "../components/Sidebar";
import axios from "axios";
import Spinner from "../components/Spinner";
import { Modal } from "./../components/Modal";

const API = localStorage.getItem("assethost");

export default class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      valid: false,
      msg: "",
      toastColor: "",
      users: [],
      roles: [],
      page: 0,
      size: 10,
      totalPages: 1,

      showEditModal: false,
      activeStatus: "",
      roleId: "",
      userId: "",

      errors: {},
    };
    this.fetchUsers = this.fetchUsers.bind(this);
    this.fetchRoles = this.fetchRoles.bind(this);
    this.fetchUserById = this.fetchUserById.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.fetchUsers(0, 10);
    this.fetchRoles();
  }

  fetchUsers(page, size) {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(`${API}/users/getall`, {
        params: { page, size },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let users = [];
        let totalPages = 1;

        if (Array.isArray(response.data)) {
          users = response.data;
        } else if (Array.isArray(response.data.users)) {
          users = response.data.users;
          const totalElements = response.data.totalElements || users.length;
          const size = response.data.size || 10;
          totalPages = Math.ceil(totalElements / size);
        } else if (Array.isArray(response.data.content)) {
          users = response.data.content;
          totalPages = response.data.totalPages || 1;
        }

        this.setState({
          users,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (error.response?.status === 403) {
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          users: [],
          totalPages: 1,
          loading: false,
          msg: error?.response?.data?.message || "Failed to load users.",
          toastColor: "danger",
        });
      });
  }

  fetchRoles() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(`${API}/users/getformdata`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          roles: response.data.roles,
          loading: false,
        });
      })
      .catch((error) => {
        if (error.response?.status === 403) {
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          roles: [],
          loading: false,
          msg: error?.response?.data?.message || "Failed to load roles.",
          toastColor: "danger",
        });
      });
  }

  fetchUserById(id) {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(`${API}/users/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const user = response.data;
        this.setState(
          {
            editingUserId: user.id || 0,
            username: user.username || "",
            fullName: user.fullName || "",
            roleId: user.roleId || 0,
            isPaidService: user.isPaidService || "NO",
            activeStatus: user.activeStatus || "YES",
            password: "",
            passwordConfirm: "",
            loading: false,
            editing: true,
          },
          this.validate
        );
      })
      .catch((error) => {
        if (error.response?.status === 403) {
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load user.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (s.editing) {
      if (!s.username.trim()) {
        errors.username = "Username is required";
        valid = false;
      }
      if (!s.fullName.trim()) {
        errors.fullName = "Full Name is required";
        valid = false;
      }
      if (!s.roleId) {
        errors.roleId = "Role is required";
        valid = false;
      }
      if (s.editingUserId === 0) {
        if (!s.password.trim()) {
          errors.password = "Password is required";
          valid = false;
        } else if (
          !/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/.test(
            s.password
          )
        ) {
          errors.password =
            "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";
          valid = false;
        }
        if (!s.passwordConfirm.trim()) {
          errors.passwordConfirm = "Password Confirm is required";
          valid = false;
        } else if (s.password !== s.passwordConfirm) {
          errors.passwordConfirm = "Passwords do not match";
          valid = false;
        }
      }
      if (!s.isPaidService.trim()) {
        errors.isPaidService = "Is Paid Service is required";
        valid = false;
      }
      if (!s.activeStatus.trim()) {
        errors.activeStatus = "Active Status is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = {
      roleId: this.state.roleId,
      activeStatus: this.state.activeStatus,
    };

    const self = this;
    axios
      .put(`${API}/users/${this.state.userId}`, request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "User updated successfully!",
            toastColor: "success",
            loading: false,
          });
          self.setState({
            activeStatus: "",
            roleId: "",
            showEditModal: false,
            valid: false,
            errors: {},
          });
          const currentPage = self.state.page;
          self.fetchUsers(currentPage, self.state.size);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save user.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save user. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(user) {
    if (user && user.id) {
      this.fetchUserById(user.id);
    } else {
      this.setState(
        {
          editingUserId: 0,
          username: "",
          fullName: "",
          roleId: 0,
          isPaidService: "NO",
          activeStatus: "YES",
          password: "",
          passwordConfirm: "",
          editing: true,
          errors: {},
        },
        this.validate
      );
    }
  }

  handleCancelEdit() {
    this.setState({
      editingUserId: 0,
      username: "",
      fullName: "",
      roleId: 0,
      isPaidService: "NO",
      activeStatus: "YES",
      password: "",
      passwordConfirm: "",
      editing: false,
      errors: {},
    });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      this.fetchUsers(this.state.page - 1, this.state.size);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      this.fetchUsers(this.state.page + 1, this.state.size);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Users" />
          {divMsg}
          <div className="w-full grow px-5 h-[60%]">
            <div className="h-full w-full">
              <div className="flex gap-2 mb-2 items-baseline justify-between">
                <h3 className="font-bold">Configured Users</h3>
                <button
                  className="hover:font-bold flex gap-1 group"
                  onClick={() => this.handleEdit(null)}
                >
                  <i
                    className="bi bi-plus-circle group-hover:scale-105"
                    style={{ color: "black" }}
                  ></i>
                  Add
                </button>
              </div>
              {s.users.length === 0 ? (
                <div className="text-gray-500">No users found.</div>
              ) : (
                <div
                  className={`overflow-x-auto w-full border relative overflow-y-auto ${
                    s.totalPages > 1 ? "h-[83%]" : "h-[93%]"
                  }`}
                >
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50 sticky top-0">
                      <tr>
                        {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th> */}
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Username
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Full Name
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Role
                        </th>
                        {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Is Paid Service?
                          </th> */}
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Active Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {s.users.map((user, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {user.id}
                            </td> */}
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {user.username}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {user.fullname}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {user.roleName}
                          </td>
                          {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {user.isPaidService}
                            </td> */}
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {user.activeStatus}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                            <button
                              className="btn btn-success"
                              onClick={() => {
                                this.setState({
                                  showEditModal: true,
                                  activeStatus: user.activeStatus,
                                  roleId: user.roleId,
                                  userId: user.id,
                                });
                              }}
                            >
                              Manage
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {s.totalPages > 1 && (
                <div className="flex justify-center items-center gap-2 mt-2">
                  <button
                    className="btn btn-outline"
                    disabled={s.page === 0}
                    onClick={this.handlePreviousPage}
                  >
                    Previous
                  </button>
                  <span>
                    Page {s.page + 1} of {s.totalPages}
                  </span>
                  <button
                    className="btn btn-outline"
                    disabled={s.page + 1 >= s.totalPages}
                    onClick={this.handleNextPage}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
          <Footer />
        </div>

        {s.showEditModal && (
          <Modal
            title="Manage user"
            closeAction={() => this.setState({ showEditModal: false })}
            footerContent={
              <>
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={s.loading}
                  form="announcementForm"
                  onClick={this.handleSave}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() =>
                    this.setState({
                      valid: false,
                      activeStatus: "",
                      roleId: "",
                      errors: {},
                      showEditModal: false,
                    })
                  }
                >
                  Close
                </button>
              </>
            }
          >
            <form autoComplete="off" id="usermanage" onSubmit={this.handleSave}>
              <div className="row">
                <div className="col">
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <select
                      name="activeStatus"
                      className={`form-control ${
                        s.errors.activeStatus ? " !border-red-500" : ""
                      }`}
                      value={s.activeStatus}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select...</option>
                      <option value="YES">Yes</option>
                      <option value="NO">No</option>
                    </select>
                    {s.errors.activeStatus && (
                      <span className="input-group-error">
                        {s.errors.activeStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col">
                  <div className="input-group">
                    <label className="input-group-text">Role</label>
                    <select
                      name="roleId"
                      className={`form-control ${
                        s.errors.roleId ? " !border-red-500" : ""
                      }`}
                      value={s.roleId}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select...</option>
                      {s.roles?.length &&
                        s.roles?.map((role) => (
                          <option
                            key={`role-option-${role.id}`}
                            value={role.id}
                          >
                            {role.name}
                          </option>
                        ))}
                    </select>
                    {s.errors.roleId && (
                      <span className="input-group-error">
                        {s.errors.roleId}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </Modal>
        )}
      </div>
    );
  }
}
